import { PublicClientApplication } from "@azure/msal-browser";

// Fill these in from Azure Portal -> App registrations -> Overview
// Put them in a .env file as REACT_APP_AZURE_CLIENT_ID / REACT_APP_AZURE_TENANT_ID
// so they aren't hardcoded in source.
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
};

export const msalInstance = new PublicClientApplication(msalConfig);